import React, { useState } from 'react';
import { connect } from 'react-redux';

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import { Mail, MapPin } from 'lucide-react';

import { submitContactForm } from 'actions/actions';
import { validateEmail } from 'util/validation';

const INITIAL_FORM = {
    name: '',
    email: '',
    message: '',
};

const Contact = ({ submitContactForm }) => {
    const [contact, setContact] = useState(INITIAL_FORM);
    return (
        <div className="contact-content">
            <h2 style={{ textAlign: 'center' }}>Let's get in touch</h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-1 mb-3">
                <div className="grid grid-cols-1 md:grid-rows-3">
                    <div className="contactDiv">
                        <Typography
                            sx={{ flex: '1 1 100%' }}
                            variant="h6"
                            id="tableTitle"
                            component="div"
                        >
                            Your Name
                        </Typography>
                        <TextField
                            sx={{ minWidth: '20dvw' }}
                            value={contact.name}
                            onChange={e =>
                                setContact({
                                    ...contact,
                                    name: e.target.value,
                                })
                            }
                            error={!contact.name}
                            helperText={!contact.name ? 'Name is required' : ''}
                        />
                    </div>
                    <div className="contactDiv">
                        <Typography
                            sx={{ flex: '1 1 100%' }}
                            variant="h6"
                            id="tableTitle"
                            component="div"
                        >
                            Your Email
                        </Typography>
                        <TextField
                            sx={{ minWidth: '20dvw' }}
                            value={contact.email}
                            onChange={e =>
                                setContact({
                                    ...contact,
                                    email: e.target.value,
                                })
                            }
                            error={
                                !contact.email || !validateEmail(contact.email)
                            }
                            helperText={
                                !contact.email
                                    ? 'Email is required'
                                    : !validateEmail(contact.email)
                                    ? 'Please enter a valid email address'
                                    : ''
                            }
                        />
                    </div>
                    <div className="contactDiv">
                        <Typography
                            sx={{ flex: '1 1 100%' }}
                            variant="h6"
                            id="tableTitle"
                            component="div"
                        >
                            Message
                        </Typography>
                        <TextField
                            sx={{ minWidth: '20dvw' }}
                            value={contact.message}
                            onChange={e =>
                                setContact({
                                    ...contact,
                                    message: e.target.value,
                                })
                            }
                            multiline
                            minRows={3}
                            maxRows={6}
                        />
                    </div>
                    <div className="wrapper contactDiv">
                        <Button
                            variant="contained"
                            onClick={() => {
                                submitContactForm(contact);
                                setContact(INITIAL_FORM);
                            }}
                            disabled={
                                !contact.name ||
                                !contact.email ||
                                !validateEmail(contact.email)
                            }
                            sx={{ marginTop: '1rem' }}
                        >
                            Send Message
                        </Button>
                    </div>
                </div>
                <div className="grid grid-cols-1 md:grid-rows-3">
                    <div className="contactDiv">
                        <Typography
                            sx={{
                                display: 'flex',
                                flex: '1 1 100%',
                                alignItems: 'center',
                            }}
                            variant="h6"
                            id="tableTitle"
                            component="div"
                        >
                            <Mail size={18} className="contact-icon mr-2" />
                            Email
                        </Typography>
                        <Typography
                            sx={{ flex: '1 1 100%' }}
                            variant="body1"
                            id="tableTitle"
                            component="div"
                        >
                            <a
                                href="mailto:randolst@gmail.com"
                                className="contact-link"
                            >
                                randolst@gmail.com
                            </a>
                        </Typography>
                    </div>
                    <div className="contactDiv">
                        <Typography
                            sx={{
                                display: 'flex',
                                flex: '1 1 100%',
                                alignItems: 'center',
                            }}
                            variant="h6"
                            id="tableTitle"
                            component="div"
                        >
                            <MapPin size={18} className="contact-icon mr-2" />
                            Location
                        </Typography>
                        <Typography
                            sx={{ flex: '1 1 100%' }}
                            variant="body1"
                            id="tableTitle"
                            component="div"
                        >
                            Greater Buffalo Area, NY
                        </Typography>
                    </div>
                    <div className="contactDiv">
                        <Typography
                            sx={{ flex: '1 1 100%' }}
                            variant="h6"
                            id="tableTitle"
                            component="div"
                        >
                            Connect
                        </Typography>
                        <Typography
                            sx={{
                                display: 'flex',
                                flex: '1 1 100%',
                                alignItems: 'center',
                            }}
                            variant="body1"
                            id="tableTitle"
                            component="div"
                        >
                            <svg
                                className="contact-icon mr-2"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                            >
                                <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.28 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.75M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z" />
                            </svg>
                            <a
                                href="https://www.linkedin.com/in/shane-randolph/"
                                className="contact-link"
                            >
                                Shane Randolph on LinkedIn
                            </a>
                        </Typography>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default connect(null, {
    submitContactForm,
})(Contact);
